export interface SelectOptionLike {
    label?: unknown;
    value?: unknown;
    [key: string]: unknown;
}

/** 估算筛选下拉文本宽度，避免依赖 DOM 测量导致 SSR 或测试环境不可用。 */
export function measureSelectText(text: string, fontSize = 12): number {
    return Array.from(text).reduce((width, character) => {
        const codePoint = character.codePointAt(0) ?? 0;
        return width + (codePoint <= 0xff ? 7 : fontSize);
    }, 0);
}

/**
 * 计算多选下拉“首个完整标签 +N”所需的最小宽度。
 * 旧版 Vue 会根据已选标签动态撑开控件，React 侧也要保留这段空间，避免 Ant 默认省略号截断标签。
 */
export function getCollapsedMultiSelectWidth(
    value: unknown,
    options: SelectOptionLike[],
    placeholder: string,
    minimumWidth = 0
): number {
    const values = Array.isArray(value) ? value : value == null || value === "" ? [] : [value];
    const firstValue = values[0];
    const firstOption = options.find(option => Object.is(option.value, firstValue));
    const firstLabel = String(firstOption?.label ?? firstValue ?? placeholder);
    const tagWidth = measureSelectText(firstLabel) + 42;
    const omittedCount = Math.max(values.length - 1, 0);
    const countWidth = omittedCount > 0 ? measureSelectText(`+${omittedCount}`) + 18 : 0;
    const emptyWidth = measureSelectText(placeholder) + 44;

    return Math.ceil(Math.max(minimumWidth, values.length ? tagWidth + countWidth : emptyWidth));
}
